let config = {
    sdk: 'NIM_Web_SDK_v6.1.0',
    // 默认用户头像
    defaultUserIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/default-icon.png',
    // 本地消息显示数量，会影响性能
    localMsglimit: 36,
    useDb: false
  }
  
  const env = 'production'
  const build = process.env.VUE_APP_BUILD;
  
  let appConfig = {
    production: {
      appkey: build === "prod" || build === "release" ? 'b6c69518fe5fb965794683bf78c23282' : 'bc1643e9983948803bf1a05efbfab63b' // 'b6c69518fe5fb965794683bf78c23282'
    }
  }
  
  config = Object.assign(config, appConfig[env])
  
  export default config
  